import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import Pagination from "../Shared/Layout/Pagination";
import Axios from "axios";
import withLanguage from "../../HOC/withLanguage";
import SearchIcon from "@mui/icons-material/Search";


const pageSize = 10;

const QualificationFilters = ({ language }) => {
    const [inputValue, setInputValue] = useState("");
    const [debouncedValue, setDebouncedValue] = useState(inputValue);
    const [category, setCategory] = useState("drejtim");
    const [results, setResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);

    // Fetch data with optional search term
    const fetchData = async (searchTerm = inputValue) => {
        setIsLoading(true);
        try {
            let res;
            let url=`/api/degree_institution/${page + 1}/${pageSize}?type__exact=${category}&dual_education__exact=true`
            if (searchTerm.trim() !== "") {
                url=`${url}&name__iexact=${searchTerm}`
            }
     
            res = await Axios.get(url);
           
            setResults(res.data.records || []);
            setTotalAmount(res.data.amount || 0);
        } catch (err) {
            console.error(err);
            setResults([]);
            setTotalAmount(0);
        }
        setIsLoading(false);
    };

    // Debounce inputValue
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(inputValue);
            setPage(0); // reset page when search changes
        }, 500); // 500ms debounce delay

        return () => clearTimeout(handler);
    }, [inputValue]);

    // Fetch data whenever debouncedValue, category, or page changes
    useEffect(() => {
        fetchData(debouncedValue);
    }, [debouncedValue, category, page]);

    const handleFilterChange = (e) => {
        setInputValue("")
        setCategory(e.target.value);
        setPage(0);
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        setPage(0);
        fetchData(inputValue); // optional immediate search on submit
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    return (
        <section className="flex-1">
            {/* Search Bar */}
            <div className="flex justify-center mb-12">
                <form
                    className="flex overflow-hidden"
                    onSubmit={handleSearchSubmit}
                >
                    <input
                        type="text"
                        placeholder={language.search}
                        className="w-[350px] border border-red-300 shadow-0 px-4 py-2 rounded-l-3xl focus:outline-none text-[17px]"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                    />
                    <button type="submit" className="bg-red-600 text-white px-6 rounded-r-2xl hover:bg-red-700 flex items-center justify-center opacity-85">
                        <SearchIcon className="h-5 w-5 text-white font-extrabold" />
                    </button>
                </form>
            </div>

            {/* Filters */}
            <h2 className="text-red-600 font-extrabold text-[25px] mb-6">
                {language.filterTitle}
            </h2>

            <div className="flex max-md:flex-col flex-row gap-4 mb-8">
                <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                        type="radio"
                        name="qualification"
                        value="drejtim"
                        className="w-5 h-5 accent-red-600"
                        checked={category === "drejtim"}
                        onChange={handleFilterChange}
                    />
                    <span className="text-red-600 font-bold">{language.filter1}</span>
                </label>

                <label className="flex items-center space-x-2 cursor-pointer">
                    <input
                        type="radio"
                        name="qualification"
                        value="middle"
                        className="w-5 h-5 accent-red-600"
                        checked={category === "middle"}
                        onChange={handleFilterChange}
                    />
                    <span className="text-red-600 font-bold">{language.filter2}</span>
                </label>
            </div>

            {/* Results */}
            <div>

                {isLoading ? (
                    <p className="text-gray-500">Loading...</p>
                ) : results.length === 0 ? (
                    <p className="text-gray-500">Nuk ka rezultate.</p>
                ) : (
                    <div className="flex flex-col">
                        {results.map((item) => (
                            <Link
                                key={item.id}
                                to={`/drejtime/${item.id}`}
                                className="border-[1.5px] border-red-600 rounded-[10px] p-2.5 mb-5 cursor-pointer hover:bg-red-50"
                            >
                                <span className="text-black font-bold">{item.name}</span>
                            </Link>
                        ))}
                    </div>
                )}

                {totalAmount > pageSize && (
                    <Pagination
                        count={totalAmount}
                        pageSize={pageSize}
                        page={page}
                        action={handlePageChange}
                    />
                )}
            </div>
        </section>
    );
};

export default withLanguage(QualificationFilters, "QualificationFilters");
